import { Fragment } from 'react';

/**
 * A library description, with its backticked spans set as code.
 *
 * The descriptions come from the front matter and manifests curators write,
 * and they are written as markdown prose — `cfl`, `.agents`, `speckit.plan`.
 * Rendering the whole string as markdown would be too much power for one line
 * of a list row (headings, links and images could all arrive), so exactly one
 * thing is honoured here: the code span. Everything else is text.
 */
export function InlineCode({ text }: { text: string }) {
  const parts = text.split(/`([^`]+)`/g);
  return (
    <>
      {parts.map((part, index) =>
        // The index is the identity here: `split` returns the same pieces in
        // the same order for the same string, and the string is the only input.
        index % 2 === 1 ? (
          <code key={index} className="font-mono text-[0.9em]">
            {part}
          </code>
        ) : (
          <Fragment key={index}>{part}</Fragment>
        ),
      )}
    </>
  );
}
